module.exports = __webpack_public_path__ + "img/message_systerm@2x.ca128153.png";